/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/naming-convention */
import React from 'react';
import { ICoreContext } from '../interfaces';
import { CoreContext } from '../models';

/**
 * HOC that injects all the content of the generic context into the component
 * @param Component The component that the context will be injected into
 */
export function WithContext(Component: any): (props: any) => JSX.Element {
    return function ComponentWithContext(props: any): JSX.Element {
        return (
            <CoreContext.Consumer>
                {(value: ICoreContext) => (
                    <Component
                        {...props}
                        context={value}
                        telemetry={value.telemetry.setTelemetryModuleContext({ moduleId: props.id, moduleType: props.typeName })()}
                        // @ts-ignore -- we don't actually have this prop defined on the interface
                        internalTelemetry={value.internalTelemetry.setTelemetryModuleContext({
                            moduleId: props.id,
                            moduleType: props.typeName
                        })()}
                        app={value.app}
                    />
                )}
            </CoreContext.Consumer>
        );
    };
}
